import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/globals.css";
import { installSessionFetch } from "./lib/sessionFetch";
import { installStaleChunkReload } from "./lib/staleChunk";

// Kayan oturum + suresi dolan oturumda girise yonlendirme (tum fetch'ler)
installSessionFetch();
// Deploy sonrasi eski parca dosyasi istenirse sayfa bir kez yenilenir
installStaleChunkReload();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
